<template>
	<div class="webview">
		<table class="table-main">
			<thead>
				<tr>
					<th>번호</th>
					<th>등록일시</th>
					<th>화면명</th>
					<th>URL</th>
					<th>조회수</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="item in list">
					<td>
						{{ item.id }}
					</td>
					<td>
						{{ item.createdDateStr }}
					</td>
					<td>
						<router-link
							class="webview__link"
							:to="`/operation/webview/modify/${item.id}`"
						>
							{{ item.title }}
						</router-link>
					</td>
					<td>
						{{ baseUrl }}/webviewTemplate.html?id={{ item.id }}
						<button
							class="btn"
							v-clipboard:copy="
								`${baseUrl}/webviewTemplate.html?id=${item.id}`
							"
						>
							복사
						</button>
					</td>
					<td>
						{{ item.viewCount || 0 }}
					</td>
				</tr>
			</tbody>
		</table>
		<pagination-box
			:totalItem="total"
			:limit="limit"
			:offset="offset"
			:pageLengPerOne="10"
			@to="paging"
			slot="pagination"
		/>
	</div>
</template>
<script>
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'WebviewManage',
		components: {
			PaginationBox,
		},
		data() {
			const baseUrl =
				process.env.NODE_ENV === 'development'
					? 'https://static.glowpick.net/webview'
					: 'https://static.glowpick.com/webview';

			return {
				baseUrl,
				list: [],
				limit: 10,
				offset: 0,
				total: 0,
			};
		},
		mounted() {
			this.getList();
		},
		methods: {
			paging(arg) {
				this.offset = arg.offset;
				this.getList();
			},
			getList() {
				this.$axiosAdmin2
					.get(
						`/api/webviews?offset=${this.offset}&limit=${this.limit}`
					)
					.then(({ data }) => {
						this.list = data.data;
						this.total = data.contentTotal;
					})
					.catch(({ response }) => {
						console.error(response);
					});
			},
		},
	};
</script>
<style lang="scss" scoped>
	.pagination-box {
		padding-top: 40px;
	}

	.btn {
		display: inline-block;
		margin-left: 1em;
		vertical-align: middle;
	}

	.webview__link {
		color: $btn-blue;
		font-weight: bold;
	}
</style>
